import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import CardDnd, { Container, Loadding } from '../../components/StyleComponent'
import { Box } from '@mui/material'
import axiosInstance from '../../config/axiosConfig'
import { urlConfig } from '../../config/apiConfig'
import { WidthProvider, Responsive } from 'react-grid-layout'
import WeatherCard from '../../components/WeatherCard'
import { useAuth } from '../../hook/useAuth'
import PopupAlert from '../../components/PopupAlert'
import { AlertContext } from '../../context/AlertContext'
import ModalAllowSound from './ModalAllowSound'
import { useSoundPermission } from '../../context/AllowContext'
const ResponsiveGridLayout = WidthProvider(Responsive)

export default function UserDashboard({
    imageUrl,
    setImageUrl,
    typeCard,
    connectedWB,
}) {
    const [positions, setPositions] = useState({})
    const [images, setImages] = useState('')
    const [imagesCheck, setImagesCheck] = useState(false)
    const [cardItem, setCardItem] = useState([])
    const [popup, setPopup] = useState(false)
    const [skip, setSkip] = useState(false)
    const { auth } = useAuth()
    const keyName = auth.keyName || 'kumwell'
    const [cardMode, setCardMode] = useState('normal')
    const [sound, setSound] = useState('')
    const { handleOpen } = useContext(AlertContext)
    const { isSoundAllowed } = useSoundPermission()
    const [hasAlarm, setHasAlarm] = useState({ alarm: false, type: '' })
    // const [hasAlarmTest, setHasAlarmTest] = useState({ alarm: false, type: '' })
    const lastPlayedRef = useRef(null)
    const audioRef = useRef(null)
    const currentTypeRef = useRef(null)

    const handleWebSocketData = useCallback(() => {
        if (!typeCard || !typeCard.data) return
        const filtered = typeCard.data.filter((item) => item.isInDashboard)
        const filteredPositions = filtered.reduce((accumulator, item) => {
            accumulator[item._id] = {
                ...item.position,
                w: 2,
                h: item.params?.length > 3 ? 3 : 2,
            }
            return accumulator
        }, {})

        const data = typeCard.data || []

        if (data[0]) {
            const filterAlarm = data.filter((item) => !!item.alarm) || []

            const triggerAlarm =
                filterAlarm.filter(
                    (item) => item.alarm_type === 'Trigger state',
                ) || []

            const remainAlarmWithPopup =
                filterAlarm.filter(
                    (item) =>
                        item.alarm_type === 'Remain state' && item.alarm_popup,
                ) || []

            if (remainAlarmWithPopup.length > 0) {
                // If there is no Trigger, but Remain state with popup
                if (
                    !hasAlarm ||
                    hasAlarm.alarm !== true ||
                    hasAlarm.type !== 'Remain state'
                ) {
                    // console.log('newType', 'Remain state')
                    setHasAlarm({ alarm: true, type: 'Remain state' })
                }
            } else if (triggerAlarm.length > 0) {
                // If there is any Trigger state, prioritize it
                if (
                    !hasAlarm ||
                    hasAlarm.alarm !== true ||
                    hasAlarm.type !== 'Trigger state'
                ) {
                    // console.log('newType', 'Trigger state')
                    setHasAlarm({ alarm: true, type: 'Trigger state' })
                }
            } else {
                // No alarms to set
                if (hasAlarm !== null) {
                    setHasAlarm(null)
                }
            }
        }

        setCardMode(typeCard.card_size || 'normal')
        setPositions(filteredPositions)
        setCardItem(
            filtered.map((item) => ({
                ...item,
                position: { ...item.position },
            })),
        )
        filtered.forEach((item) => {
            if (item.alarm_popup) {
                setPopup(true)
            }
        })
        setImagesCheck(true)
    }, [typeCard])

    const getDevice = useCallback(async () => {
        try {
            const res = await axiosInstance.get(`${urlConfig.card}/${keyName}`)
            const data = res.data.message || []

            const filtered = res.data.message.filter(
                (item) => item.isInDashboard,
            )
            const filteredPositions = filtered.reduce((accumulator, item) => {
                accumulator[item._id] = {
                    ...item.position,
                    w: 2,
                    h: item.params?.length > 3 ? 3 : 2,
                }
                return accumulator
            }, {})

            if (data[0]) {
                const filterAlarm = data.filter((item) => !!item.alarm) || []

                const triggerAlarm =
                    filterAlarm.filter(
                        (item) => item.alarm_type === 'Trigger state',
                    ) || []

                const remainAlarmWithPopup =
                    filterAlarm.filter(
                        (item) =>
                            item.alarm_type === 'Remain state' &&
                            item.alarm_popup,
                    ) || []
                if (remainAlarmWithPopup.length > 0) {
                    // If there is no Trigger, but Remain state with popup
                    if (
                        !hasAlarm ||
                        hasAlarm.alarm !== true ||
                        hasAlarm.type !== 'Remain state'
                    ) {
                        // console.log('newType', 'Remain state')
                        setHasAlarm({ alarm: true, type: 'Remain state' })
                    }
                } else if (triggerAlarm.length > 0) {
                    // If there is any Trigger state, prioritize it
                    if (
                        !hasAlarm ||
                        hasAlarm.alarm !== true ||
                        hasAlarm.type !== 'Trigger state'
                    ) {
                        // console.log('newType', 'Trigger state')
                        setHasAlarm({ alarm: true, type: 'Trigger state' })
                    }
                } else {
                    // No alarms to set
                    if (hasAlarm !== null) {
                        setHasAlarm(null)
                    }
                }
            }

            setCardMode(res.data.card_size)
            setPositions(filteredPositions)

            setCardItem(
                data?.map((item) => ({
                    ...item,
                    position: { ...item.position },
                })),
            )

            filtered.forEach((item) => {
                if (item.alarm_popup) {
                    setPopup(true)
                }
            })

            setImagesCheck(true)
            handleOpen({ open: false })
        } catch (error) {
            handleOpen({
                open: true,
                message: `${error.response?.data.message}`,
                isSuccess: false,
            })
        }
    }, [keyName, handleOpen, hasAlarm])

    useEffect(() => {
        if (connectedWB && typeCard) {
            handleWebSocketData()
        }
    }, [connectedWB, typeCard, handleWebSocketData])
    useEffect(() => {
        let timeoutId
        let cancelled = false

        const fetchLoop = async () => {
            if (!connectedWB || !typeCard) {
                try {
                    await getDevice()
                } catch (error) {
                    console.error('getDevice failed:', error)
                }
                if (!cancelled) {
                    timeoutId = setTimeout(fetchLoop, 1000)
                }
            }
        }

        fetchLoop()

        return () => {
            cancelled = true
            clearTimeout(timeoutId)
        }
    }, [connectedWB, typeCard])

    const getImg = useCallback(async () => {
        const localStorageKey = `image_${auth.keyName}`
        try {
            const res = await axiosInstance.get(
                `${urlConfig.imageByKey}/${auth.keyName}`,
                {
                    responseType: 'blob',
                },
            )
            const blob = new Blob([res.data], { type: 'image/png' })
            const imageUrl = URL.createObjectURL(blob)
            localStorage.setItem(localStorageKey, imageUrl)
            localStorage.setItem(
                `${localStorageKey}_timestamp`,
                Date.now().toString(),
            )

            setImageUrl(imageUrl)
        } catch (error) {}
    }, [auth.keyName, setImageUrl])

    const getSound = useCallback(async () => {
        try {
            const res = await axiosInstance.get(
                `${urlConfig.organization}/${auth.keyName}`,
            )
            const myRes = res.data.message

            if (myRes.enable_sound) {
                if (
                    myRes.trigger_sound &&
                    myRes.trigger_sound === myRes.remain_sound
                ) {
                    const resSound = await axiosInstance.get(
                        `${urlConfig.sound}/${myRes.trigger_sound}`,
                        {
                            responseType: 'arraybuffer',
                        },
                    )
                    if (resSound.data) {
                        const blob = new Blob([resSound.data], {
                            type: 'audio/wav',
                        })
                        const soundUrl = URL.createObjectURL(blob)

                        setSound({
                            trigger_sound: soundUrl,
                            remain_sound: soundUrl,
                        })

                        // Cleanup URLs when component unmounts
                        return () => {
                            URL.revokeObjectURL(soundUrl)
                        }
                    }
                } else if (myRes.trigger_sound && myRes.remain_sound) {
                    const [triggerRes, remainRes] = await Promise.all([
                        axiosInstance.get(
                            `${urlConfig.sound}/${myRes.trigger_sound}`,
                            {
                                responseType: 'arraybuffer',
                            },
                        ),
                        axiosInstance.get(
                            `${urlConfig.sound}/${myRes.remain_sound}`,
                            {
                                responseType: 'arraybuffer',
                            },
                        ),
                    ])

                    const triggerBlob = new Blob([triggerRes.data], {
                        type: 'audio/wav',
                    })
                    const remainBlob = new Blob([remainRes.data], {
                        type: 'audio/wav',
                    })

                    const triggerSoundUrl = URL.createObjectURL(triggerBlob)
                    const remainSoundUrl = URL.createObjectURL(remainBlob)

                    setSound({
                        trigger_sound: triggerSoundUrl,
                        remain_sound: remainSoundUrl,
                    })

                    // Cleanup URLs when component unmounts
                    return () => {
                        URL.revokeObjectURL(triggerSoundUrl)
                        URL.revokeObjectURL(remainSoundUrl)
                    }
                }
            }
        } catch (error) {
            console.error('Error fetching sound:', error)
        }
    }, [auth.keyName])

    // console.log(sound)

    const fixBugWeather = (id) => {
        const dataW = { x: 0, y: 0, ...positions[id], w: 3, h: 1.4 * 3 }
        return dataW
    }

    useEffect(() => {
        getSound()
    }, [getSound])

    useEffect(() => {
        if (!imageUrl) {
            getImg()
        }
    }, [getImg, imageUrl])

    const sizeCard = {
        normal: { h: 3, w: 2 },
        medium: { h: 4, w: 3 },
        large: { h: 5, w: 4 },
    }[cardMode]

    const updateWarning = async (id) => {
        try {
            await axiosInstance.put(`${urlConfig.device}/popup/${id}`, {
                alarm_popup: false,
            })
        } catch (err) {}
    }

    useEffect(() => {
        if (skip) {
            const intervalId = setInterval(() => {
                setSkip(false)
            }, 100)
            return () => clearInterval(intervalId)
        }
    }, [skip])

    const getCard = () => {
        const fetchAllImages = async () => {
            try {
                const uniqueDeviceTypes = [
                    ...new Set(
                        cardItem
                            ?.map((item) => item.key_type_id)
                            .filter((type) => type !== undefined),
                    ),
                ]
                const imagePromises = uniqueDeviceTypes?.map((deviceType) =>
                    getIcon(deviceType),
                )
                const imageResults = await Promise.all(imagePromises)

                if (imageResults && imageResults[0]) {
                    setImages(imageResults)
                }
            } catch (error) {
                // console.error('Error fetching images:', error)
            }
        }
        if (!images) {
            fetchAllImages()
        }
    }

    useEffect(getCard, [imagesCheck, images, cardItem])

    const getIcon = async (deviceType) => {
        try {
            const res = await axiosInstance.get(
                `${urlConfig.deviceType}/${deviceType}`,
            )
            return { deviceType, image: res.data }
        } catch (error) {
            // console.error(
            //     `Error fetching image for device type ${deviceType}:`,
            //     error,
            // )
            return { deviceType, image: null }
        }
    }

    // const playSound = (url, type, stop, loop = false) => {
    //     const isPlaying = audioRef.current && !audioRef.current.paused
    //     if (isPlaying && stop) {
    //         audioRef.current.pause()
    //         audioRef.current.currentTime = 0
    //         return
    //     }
    //     if (!url || !type) return

    //     if (isPlaying && type === 'Remain state') {
    //         return
    //     }
    //     if (isPlaying && type !== currentTypeRef.current) {
    //         audioRef.current.pause()
    //         audioRef.current.currentTime = 0
    //     }
    //     const audio = new Audio(url)

    //     audio.loop = loop
    //     audioRef.current = audio
    //     currentTypeRef.current = type

    //     audio.play().catch((e) => {
    //         console.warn('Audio play failed:', e)
    //     })
    // }

    // useEffect(() => {
    //     if (hasAlarm) {
    //         if (!sound || !hasAlarm?.alarm || !isSoundAllowed) return
    //         const currentType = hasAlarm.type
    //         const soundUrl =
    //             currentType === 'Remain state'
    //                 ? sound.remain_sound
    //                 : sound.trigger_sound

    //         if (lastPlayedRef.current !== currentType) {
    //             playSound(soundUrl, currentType, null, true)
    //             lastPlayedRef.current = currentType
    //         }
    //     } else {
    //         playSound(null, null, true)
    //     }
    // }, [sound, hasAlarm, isSoundAllowed])

    // useEffect(() => {
    //     if (!hasAlarm?.alarm) {
    //         lastPlayedRef.current = null
    //     }
    // }, [hasAlarm])

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setHasAlarmTest((prev) => {
    //             if (!prev.alarm) {
    //                 return { alarm: true, type: 'Trigger state' }
    //             }
    //             return prev.type === 'Trigger state'
    //                 ? { alarm: true, type: 'Remain state' }
    //                 : { alarm: false, type: '' }
    //         })
    //     }, 5000)

    //     return () => clearInterval(interval)
    // }, [])

    //////////////// using this
    useEffect(() => {
        if (hasAlarm?.alarm) {
            if (!sound || !isSoundAllowed) return
            if (hasAlarm.type === 'Remain state' && !popup) {
                if (audioRef.current) {
                    audioRef.current.pause()
                    audioRef.current.currentTime = 0
                    audioRef.current = null
                    currentTypeRef.current = null
                }
                return
            }
            const currentType = hasAlarm.type
            const soundUrl =
                currentType === 'Remain state'
                    ? sound.remain_sound
                    : sound.trigger_sound

            if (
                !audioRef.current ||
                audioRef.current.paused ||
                currentType !== currentTypeRef.current
            ) {
                if (audioRef.current) {
                    audioRef.current.pause()
                    audioRef.current.currentTime = 0
                }
                const audio = new Audio(soundUrl)
                audio.loop = true
                audioRef.current = audio
                currentTypeRef.current = currentType

                audio.play().catch((e) => {
                    console.warn('Audio play failed:', e)
                })
            }
        } else {
            if (audioRef.current) {
                audioRef.current.pause()
                audioRef.current.currentTime = 0
                audioRef.current = null
                currentTypeRef.current = null
            }
        }
    }, [sound, hasAlarm, isSoundAllowed, popup])

    useEffect(() => {
        if (!hasAlarm?.alarm) {
            lastPlayedRef.current = null
        }
    }, [hasAlarm])
    //////////////// using this

    return (
        <Container title={false} dashboard={true}>
            <Box
                sx={{
                    padding: '15px 10px',
                    backgroundImage: imageUrl
                        ? `url('${imageUrl}')`
                        : 'url(/images/dfbg.png)',
                    backgroundSize: 'cover',
                    // maxWidth: '1400px',
                    // background: !imageUrl && 'grey',
                    height: '100%',
                    width: '100%',
                }}
            >
                {cardItem ? (
                    <ResponsiveGridLayout
                        className='layout'
                        cols={{
                            lg: 12,
                            md: 12,
                            sm: 12,
                            xs: 12,
                            xxs: 12,
                        }}
                        rowHeight={36}
                        isDraggable={false}
                        isResizable={false}
                        preventCollision={true}
                        compactType={null}
                        // maxRows={7 * 3}
                        maxRows={18}
                    >
                        {cardItem.map((item, index) =>
                            item.isInDashboard && item.type !== 'Weather' ? (
                                <Box
                                    data-grid={{
                                        ...positions[item._id],
                                        ...sizeCard,
                                    }}
                                    key={item._id}
                                    className='grid-item'
                                    sx={{
                                        boxShadow:
                                            'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                                        cursor: 'pointer',
                                        borderRadius: '5px',
                                        overflow: 'hidden',
                                    }}
                                >
                                    <CardDnd
                                        images={images}
                                        cardMode={cardMode}
                                        data={item}
                                        warn={!!item.alarm}
                                        type={item.alarm_type}
                                    />

                                    {isSoundAllowed && (
                                        <PopupAlert
                                            message={item.alarm_message || ''}
                                            updateWarning={() => {
                                                setPopup(false)
                                                updateWarning(item.device_id)
                                                getCard()
                                            }}
                                            open={!!item.alarm_popup && popup}
                                            handleClose={() => setSkip(true)}
                                        />
                                    )}
                                </Box>
                            ) : (
                                item.isInDashboard && (
                                    <Box
                                        data-grid={fixBugWeather(item._id)}
                                        key={item._id}
                                        className='grid-item'
                                        sx={{
                                            boxShadow:
                                                'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                                            cursor: 'pointer',
                                            borderRadius: '5px',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <WeatherCard />
                                    </Box>
                                )
                            ),
                        )}
                    </ResponsiveGridLayout>
                ) : (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '80%',
                        }}
                    >
                        <Loadding />
                    </Box>
                )}
            </Box>
            <ModalAllowSound />
        </Container>
    )
}
